import React from 'react';
import Tippy from '@tippyjs/react';
import type { TippyProps } from '@tippyjs/react';

interface Props extends TippyProps {
  /**
   * Sets tooltip content.
   */
  tooltipMessage: React.ReactNode;
}

const Tooltip = ({ tooltipMessage, appendTo = () => document.body, children, ...other }: Props): JSX.Element => (
  <Tippy
    content={tooltipMessage}
    theme={'light-border'}
    interactive
    interactiveBorder={10}
    allowHTML
    appendTo={appendTo}
    {...other as TippyProps}
  >
    {children}
  </Tippy>
);

Tooltip.displayName = 'Tooltip';

export default Tooltip;
